goog.provide('yext.entity.fields.PriceRange');
goog.provide('yext.entity.fields.PriceRangeModel');

goog.require('yext');
goog.require('yext.location.Select');
goog.require('yext.location.helpers');

/**
 * @constructor
 * @param {!Object} data Plain object version of the model
 */
yext.entity.fields.PriceRangeModel = function(data) {
  this.set(data);
};

/**
 * Set the model values from provided data
 * @param {!Object} data Plain object version of the model
 */
yext.entity.fields.PriceRangeModel.prototype.set = function(data) {
  this.minValue = data.minValue;
  this.maxValue = data.maxValue;
  this.currencyCode = data.currencyCode;
  this.indeterminate = Boolean(data.indeterminate);
  this.timestamp = data.timestamp;
};

/**
 * Set the min value
 * @param {string} value
 */
yext.entity.fields.PriceRangeModel.prototype.setMinValue = function(value) {
  if (this.minValue != value) {
    this.minValue = value;
    this.emitUpdate();
  }
};

/**
 * Set the max value
 * @param {string} value
 */
yext.entity.fields.PriceRangeModel.prototype.setMaxValue = function(value) {
  if (this.maxValue != value) {
    this.maxValue = value;
    this.emitUpdate();
  }
};

/**
 * Set the currency code
 * @param {string} value
 */
yext.entity.fields.PriceRangeModel.prototype.setCurrencyCode = function(code) {
  if (this.currencyCode != code) {
    this.currencyCode = code;
    this.emitUpdate();
  }
};

/**
 * Set the indeterminate flag
 * @param {boolean} indeterminate
 */
yext.entity.fields.PriceRangeModel.prototype.setIndeterminate = function(indeterminate) {
  if (this.indeterminate != indeterminate) {
    this.indeterminate = indeterminate;
    this.emitUpdate();
  }
};

/**
 * Emit a message when the model has changed
 */
yext.entity.fields.PriceRangeModel.prototype.emitUpdate = function() {
  $(this).trigger('updated');
};

/**
 * @return {!Object} Plain version of the model
 */
yext.entity.fields.PriceRangeModel.prototype.copy = function() {
  return {
    minValue: this.minValue,
    maxValue: this.maxValue,
    currencyCode: this.currencyCode,
    indeterminate: this.indeterminate,
    timestamp: this.timestamp,
  };
};

/**
 * @return {boolean} True if the field is empty
 */
yext.entity.fields.PriceRangeModel.prototype.isEmpty = function() {
  return !this.hasMinValue()
         && !this.hasMaxValue()
         && !this.indeterminate;
};

/**
 * @return {boolean} True if the min value is empty
 */
yext.entity.fields.PriceRangeModel.prototype.hasMinValue = function() {
  return !this.emptyNumericValue(this.minValue);
};

/**
 * @return {boolean} True if the max value is empty
 */
yext.entity.fields.PriceRangeModel.prototype.hasMaxValue = function() {
  return !this.emptyNumericValue(this.maxValue);
};

/**
 * @param {number} value A min or max value, to be checked for emptiness
 * @return {boolean} True if the provided value is empty
 */
yext.entity.fields.PriceRangeModel.prototype.emptyNumericValue = function(value) {
  return value === '' || isNaN(value);
};

/**
 * @constructor
 * @param {!jQuery} $ctx The module element context
 */
yext.entity.fields.PriceRange = function($ctx) {
  this.$ctx = $ctx;
  this.$field = $ctx.find('.js-price-range-field').addBack().filter('.js-price-range-field');
  this.$min = this.$field.find('.js-price-range-min-input');
  this.$max = this.$field.find('.js-price-range-max-input');
  this.$fieldValue = this.$field.find('.js-field-value');

  this.defaultCurrencyCode = this.$field.data('defaultCurrencyCode');
  this.currency = new yext.location.Select(this.$field.find('.js-select-wrap'));
  this.model = this.buildModel();

  this.storeValue();
  this.syncValues();
  this.setFieldValue();
  this.bind();
};

/**
 * Store a copy of the model that can be restored
 */
yext.entity.fields.PriceRange.prototype.storeValue = function() {
  this.storedValue = this.model.copy();
};

/**
 * Set the hidden input containing the fields JSON value
 */
yext.entity.fields.PriceRange.prototype.setFieldValue = function() {
  this.$fieldValue.val(yext.JSON.stringify(this.getValue()));
};

/**
 * Extract the field value as JSON from the DOM and build the model
 * @return {yext.entity.fields.PriceRangeModel}
 */
yext.entity.fields.PriceRange.prototype.buildModel = function() {
  var data = this.$field.data('value');
  return new yext.entity.fields.PriceRangeModel({
    minValue: data['minValue'],
    maxValue: data['maxValue'],
    currencyCode: data['currencyCode'],
    indeterminate: data['indeterminate'],
    timestamp: data['timestamp'],
  });
};

/**
 * When navigating back to the page, values will be synced from the DOM
 */
yext.entity.fields.PriceRange.prototype.syncValues = function() {
  this.model.setMinValue(this.$min.val());
  this.model.setMaxValue(this.$max.val());
  this.model.setCurrencyCode(this.currency.getValue());
};

/**
 * Bind all listeners to the model and the module
 */
yext.entity.fields.PriceRange.prototype.bind = function() {
  var self = this;

  this.$min.on('input', function() {
    self.model.setMinValue(self.$min.val());
  });

  this.$max.on('input', function() {
    self.model.setMaxValue(self.$max.val());
  });

  $(this.currency).on('updated', function() {
    var currencyCode = self.currency.getValue();
    // Fall back to default when field is 'cleared'
    if (!currencyCode) {
      currencyCode = self.defaultCurrencyCode;
    }
    self.model.setCurrencyCode(currencyCode);
  });

  this.$field.find('.js-reset-field-indeterminate').click(function() {
    self.model.setIndeterminate(false);
  });

  $(this.model).on('updated', function() {
    self.onUpdated();
  });
};

/**
 * Set the field to its stored value
 */
yext.entity.fields.PriceRange.prototype.reset = function() {
  this.set(this.storedValue);
};

yext.entity.fields.PriceRange.prototype.set = function(field) {
  this.model.set(field);
  this.storeValue();
  this.render();
};

/**
 * @return {!Object} The string keyed value of this field
 */
yext.entity.fields.PriceRange.prototype.getValue = function() {
  return {
    'minValue': this.model.minValue,
    'maxValue': this.model.maxValue,
    'currencyCode': this.model.currencyCode,
    'indeterminate': this.model.indeterminate,
    'timestamp': this.model.timestamp,
  };
};

/**
 * When the field changes, the following steps are taken
 */
yext.entity.fields.PriceRange.prototype.onUpdated = function() {
  this.render();
  this.setFieldValue();
  this.emitUpdate();
};

/**
 * Sync the model with the DOM
 */
yext.entity.fields.PriceRange.prototype.render = function() {
  this.$min.val(this.model.minValue);
  this.$max.val(this.model.maxValue);
  this.currency.set({
    value: this.model.currencyCode,
    displayValue: this.model.currencyCode,
  });
  this.$field.find('.js-price-range-indeterminate-message').toggle(this.model.indeterminate);
  this.$field.find('.js-price-range-field-table').toggle(!this.model.indeterminate);
};

/**
 * When the model changes, we emit an update
 */
yext.entity.fields.PriceRange.prototype.emitUpdate = function() {
  $(this).trigger('updated');
};

/**
 * @return {string|HTMLElement} Generates display mode
 */
yext.entity.fields.PriceRange.prototype.getDisplayValue = function() {
  if (this.model.isEmpty()) {
    return yext.location.helpers.emptyFieldMessage();
  }
  if (this.model.hasMaxValue()) {
    return this.model.minValue + ' - ' + this.model.maxValue +
      ' (' + this.currency.getDisplayValue() + ')';
  } else {
    return this.model.minValue + ' - ' + yext.msg('No Maximum') +
      ' (' + this.currency.getDisplayValue() + ')';
  }
};
